import { CASES_LIST_TAG } from '@/api/constants';
import { api } from '@/api/core';
import { buildCaseFilesFilterParams, type CaseFilesQueryFilters } from './getCaseFiles';

export type GetCaseFilesHistoryIdsRequest = CaseFilesQueryFilters;

export interface GetCaseFilesHistoryIdsResponse {
  /** Every history row id matching the request filters, in one response (no pagination). */
  historyRowIds: string[];
  count: number;
}

const getCaseFilesHistoryIdsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCaseFilesHistoryIds: builder.query<GetCaseFilesHistoryIdsResponse, GetCaseFilesHistoryIdsRequest>({
      query: (args) => ({
        url: '/matter/history-ids',
        method: 'GET',
        params: buildCaseFilesFilterParams(args),
      }),
      providesTags: (_result, _error, { caseId }) => [{ type: CASES_LIST_TAG, id: `case-files-history-ids-${caseId}` }],
    }),
  }),
});

export const { useLazyGetCaseFilesHistoryIdsQuery } = getCaseFilesHistoryIdsApi;
